import { render } from "./ActivitiesPriorityIconButton.vue?vue&type=template&id=255afd52&scoped=true"
import script from "./ActivitiesPriorityIconButton.vue?vue&type=script&lang=js"
export * from "./ActivitiesPriorityIconButton.vue?vue&type=script&lang=js"

import "./ActivitiesPriorityIconButton.vue?vue&type=style&index=0&id=255afd52&lang=scss&scoped=true"
import "./ActivitiesPriorityIconButton.vue?vue&type=style&index=1&id=255afd52&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255afd52"]])

export default __exports__